import { TRACKING_CATEGORIES } from '~/ci/constants';
import CiIcon from '/builds/gitlab/gitlab-ee/app/assets/javascripts/vue_shared/components/ci_icon/ci_icon.vue?vue3';
import Tracking from '/builds/gitlab/gitlab-ee/app/assets/javascripts/tracking/index.js?vue3';
import PipelinesTimeago from '/builds/gitlab/gitlab-ee/app/assets/javascripts/ci/pipelines_page/components/pipelines_timeago.vue?vue3';
export default {
    name: 'PipelineStatusBadge',
    components: {
        CiIcon,
        PipelinesTimeago
    },
    mixins: [
        Tracking.mixin()
    ],
    props: {
        pipeline: {
            type: Object,
            required: true
        }
    },
    computed: {
        pipelineStatus () {
            return this.pipeline?.details?.status || this.pipeline?.detailedStatus;
        }
    },
    methods: {
        trackClick () {
            this.track('click_ci_status_badge', {
                label: TRACKING_CATEGORIES.table
            });
        }
    }
};
